import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Grid, Header, Image, Container
} from 'semantic-ui-react'
import { pathOr } from 'ramda'
import logo from 'Images/logo.png'
import styles from './AuthStyles'

const AuthLayout = ({
  component: Component, authData, redirectTo, ...rest
}) => {
    return (
      <Route {...rest} render={matchProps => {
        const finalRedirect = pathOr(
          redirectTo, ['referrer'], matchProps.location.state)
        return !authData['access-token']
          ? <div className={styles.layout}>
              <div className='beamerTrigger' style={{display: 'none'}} />
              <Container fluid>
                <Grid textAlign='center'>
                  <Grid.Column className={styles.grid}>
                    <Header as='h2' className={styles.logoHeader}>
                      <Image src={logo} alt='logo' />
                    </Header>
                    <Component {...matchProps} />
                  </Grid.Column>
                </Grid>
              </Container>
            </div>
          : <Redirect
              exact to={finalRedirect} />
      }} />
    )
  }

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  redirectTo: state.auth.redirectTo
})

export default connect(mapStateToProps, null)(AuthLayout)



// WEBPACK FOOTER //
// ./src/Pages/Layouts/Auth.js